import { fitCallUrl as sharedFitCallUrl } from './scheduling';

// Allow Wellwired to use its own scheduler if the practices separate later.
export const fitCallUrl = process.env.REACT_APP_WELLWIRED_FIT_CALL_URL || sharedFitCallUrl;

// Keep the original page, comparison routes and inquiry on the same offer.
export const consultPrice = '$1,200';
export const blueprintRate = 'Approx. $2 / sq ft';
